import React, { useMemo, useState, useRef } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import bondImage from "../../../assets/kangaroo/BondUniversity.png";
import apply from "../../../assets/kangaroo/applybtn.svg";
import heroImage from "../../../assets/kangaroo/Home_Country_Australia.jpg";
import { Col, Container, Row } from "reactstrap";
import Button from "../../../component/button/Button";
import arrow from "../../../assets/kangaroo/arrow-cropped.svg";
import "../../../Homepage/Component/Homepage.css";
import Page8 from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import "../institution.css";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import { link, title } from "framer-motion/client";
import Map from "../../../Homepage/Map";
import InlineForm from "../../../component/InlineForm/InlineForm";
import MediumButton from "../../../component/button/MediumButton";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import FormClose from "../../../component/FormClose/FormClose";
import {
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import UniversityService from "../../../services/UniversityService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";
import website from "../../../assets/kangaroo/website.png";
import program from "../../../assets/kangaroo/program.png";
import fee from "../../../assets/kangaroo/fee.png";
import location from "../../../assets/kangaroo/location.png";
import calendar from "../../../assets/kangaroo/calendar.png";
import "../institution.css";
import { Link } from "lucide-react";
import Professional from "../../../Homepage/Professional";

const InstitutionPage = () => {
  const [institutionPage, setInstitutionPage] = useState(true);
  const router = useNavigate();
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const { slug } = useParams();
  const [visibleCount, setVisibleCount] = useState(16);

  console.log("helloajdoajf")

  // Add ref for the form section
  const formSectionRef = useRef(null);

  // Function to scroll to form
  const scrollToForm = () => {
    formSectionRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  const handleLoadMore = () => {
    if (visibleCount >= insData?.universities?.length) {
      setVisibleCount(15);
    } else {
      setVisibleCount(insData?.universities?.length || 0);
    }
  };

  const fetchDatabyId = async () => {
    if (!slug) return null;
    const response = await UniversityService.getBySlug(slug);
    console.log(response);
    return response;
  };

  const {
    isPending,
    error,
    data: insData,
  } = useQuery({
    queryKey: ["university", slug],
    queryFn: fetchDatabyId,
    enabled: !!slug,
  });
  // const fetchCountryData = async (slug) => {
  //   try {
  //     const response = await Destinationcountry.getbySlug(slug);
  //     console.log(response);
  //     return response;
  //   } catch (error) {
  //     console.error("Error fetching country data:", error);
  //     return null;
  //   }
  // };

  // const { data: countrydata } = useQuery({
  //   queryKey: ["countryData", slug],
  //   queryFn: () => fetchCountryData(slug),
  //   enabled: !!slug,
  // });


  // const parsedWhyDetails = useMemo(() => {
  //   if (!insData?.whyDetals) return { heading: "", listItems: [] };

  //   try {
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(insData.whyDetals, "text/html");

  //     const h3Element = doc.querySelector("h1, h2, h3, h4, h5, h6");
  //     const heading = h3Element ? h3Element.textContent : "";

  //     const liElements = doc.querySelectorAll("li");
  //     const listItems = Array.from(liElements).map((li) => li.innerHTML);

  //     return { heading, listItems };
  //   } catch (error) {
  //     console.error("Error parsing whyDetals:", error);
  //     return { heading: "", listItems: [] };
  //   }
  // }, [insData?.whyDetals]);

  // const parsedAreasOfStudy = useMemo(() => {
  //   if (!insData?.areasOfStudy) return { heading: "", listItems: [] };

  //   try {
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(insData.areasOfStudy, "text/html");

  //     const h3Element = doc.querySelector("h1, h2, h3, h4, h5, h6");
  //     const heading = h3Element ? h3Element.textContent : "";

  //     const liElements = doc.querySelectorAll("li");
  //     const listItems = Array.from(liElements).map((li) => li.innerHTML);

  //     return { heading, listItems };
  //   } catch (error) {
  //     console.error("Error parsing areasOfStudy:", error);
  //     return { heading: "", listItems: [] };
  //   }
  // }, [insData?.areasOfStudy]);

  const getEmbedUrl = (url) => {
    if (!url)
      return "https://www.youtube.com/embed/JynvFXYnjXU?si=ubJ4GsCzII0S7mcg";
    const match = url.match(/v=([a-zA-Z0-9_-]+)/);
    if (match) return `https://www.youtube.com/embed/${match[1]}`;
    const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
    if (url.includes("embed")) return url;
    return "https://www.youtube.com/embed/JynvFXYnjXU?si=ubJ4GsCzII0S7mcg";
  };


  // const countryDisplayNameMap = {
  //   australia: "Australian",
  //   canada: "Canadian",
  // };

  // const displayName =
  //   countryDisplayNameMap[countrydata?.name?.toLowerCase()] ||
  //   countrydata?.name?.toUpperCase() ||
  //   "DESTINATION";

  return (
    <div className="position-relative">
      <SectionContainer
        style={{
          backgroundImage: `url('${imageBaseApi + insData?.bannerMedia?.url}')`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
        }}
      >
        <BreadCrumb
          items={[
            { title: "HOME", link: "/" },
            { title: "STUDYABROAD", link: "/innerpage/australia" },
            { title: "INSTITUTIONS" },
          ]}
          instituition={true}
          country={true}
          marginBottom={"2rem"}
        />
        <div
          className="w-100  d-flex flex-column justify-content-start align-items-start"
          style={{ height: "186px" }}
        >
          <h1
            className="font-level-4 "
            style={{
              lineHeight: "3.5rem",
              fontSize: "3rem",
              color: insData?.universityNameColorCode || "#ffffff",
            }}
          >
            {insData?.name?.toUpperCase()} <br />
          </h1>
          <span
            className="font-level-8 "
            style={{
              color: "#ffffff",
              fontSize: "1.5rem",
            }}
          >
            AUSTRALIA
          </span>
        </div>
      </SectionContainer>

      <SectionContainer mainId="Instituttion-sub-page-1">
        <Container fluid className="p-0">
          <Row>
            <Col lg={6}>
              <div
                className="d-flex justify-content-center align-items-center border"
                style={{ height: "226px", width: "435px", background: "white" }}
              >
                <img
                  src={imageBaseApi + insData?.logoMedia?.url}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </Col>
            <Col
              lg={6}
              className="d-flex justify-content-end align-items-center"
              style={{ marginTop: "5rem" }}
            >
              <div onClick={scrollToForm} style={{ cursor: 'pointer' }}>
                <MediumButton
                  label="Apply Now"
                  career={true}
                  fill="#fff"
                  textColor="#83168F"
                />
              </div>
            </Col>
          </Row>

          <p className="crumbText-institution mt-5">
            {insData?.educationCode}
          </p>


          <hr
            className={`line-style mt-5 mb-0`}
          />

          <Row
            className="mt-3 mb-5 g-4  d-flex justify-content-between"
            style={{ cursor: "pointer" }}
          >
            <Col lg={3} md={6} sm={12}>
              <div className="d-flex flex-column gap-4">
                <a href={insData?.websiteUrl} className="text-decoration-none" target="_blank">

                  <div
                    className="d-flex align-items-center"

                  >
                    <div
                      style={{
                        width: "2rem",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={website} style={{ height: "2rem" }} />
                    </div>
                    <p className="crumb-heading m-0 ms-4">Website</p>
                  </div>
                </a>

                <a href={insData?.programmesUrl} className="text-decoration-none" target="_blank">
                  <div
                    className="d-flex align-items-center"

                  >
                    <div
                      style={{
                        width: "2rem",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={program} style={{ height: "2rem" }} />
                    </div>
                    <p className="crumb-heading m-0 ms-4">Programs</p>
                  </div>
                </a>

                <a href={insData?.applyUrl} className="text-decoration-none" target="_blank">
                  <div
                    className="d-flex align-items-center"

                  >
                    <div
                      style={{
                        width: "2rem",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src={fee} style={{ height: "2rem" }} />
                    </div>
                    <p className="crumb-heading m-0 ms-4">Course Fee</p>
                  </div>
                </a>
              </div>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <div className="d-flex flex-column">
                <div className="d-flex">
                  <img src={location} style={{ height: "2rem" }} />
                  <p className="crumb-heading mb-2 ms-4">Location:</p>
                </div>
                {insData?.locations?.map((item, index) => (
                  <React.Fragment key={index}>
                    <p
                      className="crumbText-institution2 mb-0"
                      style={{ marginLeft: "2.8rem" }}
                    >
                      {item?.heading}
                    </p>
                    <p
                      className="crumbText-institution3 mb-0"
                      style={{ marginLeft: "2.8rem" }}
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    />
                  </React.Fragment>
                ))}
              </div>
            </Col>

            <Col lg={3} md={6} sm={12}>
              <div className="d-flex flex-column">
                <div className="d-flex ">
                  <img src={calendar} style={{ height: "2rem" }} />
                  <p className="crumb-heading mb-2 ms-4">Intakes:</p>
                </div>
                {insData?.intakes?.map((item, index) => (
                  <div
                    key={index}
                    className="crumbText-institution3 mb-0"
                    style={{ marginLeft: "3.3rem" }}
                    dangerouslySetInnerHTML={{ __html: item?.heading }}
                  />
                ))}
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="h-50">
              <div className="ratio ratio-16x9 rounded">
                <iframe
                  width="560"
                  height="315"
                  src={getEmbedUrl(insData?.videoUrl)}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="rounded"
                />
              </div>
            </Col>
          </Row>

          <div
            className="why-details mt-5"
            dangerouslySetInnerHTML={{ __html: insData?.whyDetals || "" }}
          />

          <h1 className="font-level-8 mt-5">Overview</h1>
          <p
            className="text-black my-4"
            dangerouslySetInnerHTML={{ __html: insData?.overview }}
          />

          <div
            className="areas-of-study mt-5"
            style={{ marginBottom: "10rem" }}
            dangerouslySetInnerHTML={{ __html: insData?.areasOfStudy || "" }}
          />
        </Container>
      </SectionContainer>

      <SectionContainer mainId="Innerpage">
        <div ref={formSectionRef}>
          <Row >
            <Col>
              <h1 className="font-heading">
                Reserve Your One-to-One Education Support Session
              </h1>
              <p className="country-paragraph-text mt-3 mb-4">
               Share your details and select a suitable date and time, and our team will guide you with admissions, enrolments, and academic planning.
              </p>
            </Col>
          </Row>
        </div>

        <DynamicInlineForm
          fullName={true}
          email={true}
          phone={true}
          serviceId={true}
          callBackTime={true}
          preferedBranchId={true}
          message={true}
          buttondesc="BOOK FREE COUNSELING"
          formOrigin={8}
        />
      </SectionContainer>

      <hr className="line" />

      <SectionContainer>
        <Row>
          <Col>
            <p className="font-level-4 lh-1 mb-0 ">
              OTHER  INSTITUTIONS WE REPRESENT
            </p>
          </Col>
        </Row>

        {/* <Row className="gy-4 mt-5 ms-1">
          {insData?.universities?.filter((item) => item?.slug !== slug)
            ?.slice(0, visibleCount)
            .map((item, index) => (
              <Col
                xl={3}
                lg={4}
                md={6}
                sm={6}
                xs={12}
                key={index}
                className="p-0 d-flex justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <div
                  className="d-flex justify-content-between align-items-center border rounded mx-0"
                  style={{
                    height: "126px",
                    width: "235px",
                    maxWidth: "100%",
                  }}
                  onClick={() => router(`/destination/${item?.slug}/${slug}`)}
                >
                  <img
                    src={imageBaseApi + item?.logo?.url}
                    alt={item?.name}
                    className="rounded"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
              </Col>
            ))}
        </Row> */}
        <Professional slug={slug} />

        <Row>
          <Col className="d-flex justify-content-center align-items-center mt-5">
            <h1
              className="button-font-ins"
              style={{ cursor: "pointer" }}
              onClick={handleLoadMore}
            >
              {insData?.universities?.length >= 16 && (
                <>

                  <span style={{ color: "#7E1790" }}>
                    {visibleCount >= insData?.universities?.length
                      ? "LOAD LESS INSTITUTION"
                      : "LOAD MORE INSTITUTION"}
                  </span>
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={arrow}
                      className={
                        visibleCount >= insData?.universities?.length
                          ? "rotate-180"
                          : "rotate-90"
                      }
                      alt=""
                    />
                  </div>
                </>

              )}
            </h1>
          </Col>
        </Row>


      </SectionContainer>

      <SectionContainer mainId="Page8">
        <hr className="line" />
        <Map />
        <hr className="line-style-testprep" />
      </SectionContainer>

      <FormClose
        modal={thankYouModal}
        toggle={toggleThankYou}
        heading="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
        description="Our counselor will connect with you shortly."
      />

      <SectionContainer>
        <SmallPage institutionPage={institutionPage} countryPage={true} />
      </SectionContainer>
    </div>
  );
};

export default InstitutionPage;